import { Mail, Phone, Trash2, Check, Clock, Inbox } from "lucide-react";

const STATI = [
  { key: "nuova", label: "Nuova", icon: Inbox },
  { key: "in lavorazione", label: "In lavorazione", icon: Clock },
  { key: "chiusa", label: "Chiusa", icon: Check },
];

const BADGE = {
  nuova: "bg-[#E0708A] text-white",
  "in lavorazione": "bg-[#F4E7D4] text-[#8A5A1E]",
  chiusa: "bg-[#E4EFE6] text-[#2F6B42]",
};

const formatData = (iso) =>
  new Date(iso).toLocaleString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

const esitoEmail = (v) =>
  !v ? "—" : v.startsWith("sent") || v === "ok" ? "inviata" : v;

export const RichiestaCard = ({ r, onStato, onDelete }) => (
  <article
    className="rounded-[24px] border border-[#E8E2E4] bg-white p-6"
    data-testid={`richiesta-card-${r.id}`}
  >
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <div className="flex flex-wrap items-center gap-2">
          <h3 className="font-display text-xl text-[#1A1617]" data-testid={`richiesta-nome-${r.id}`}>
            {r.nome}
          </h3>
          <span className="rounded-full bg-[#F3EFF0] px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-[#5E2A52]">
            {r.tipo === "storia" ? "Storia" : r.tipo === "sponsor" ? "Sponsor" : r.tipo}
          </span>
          <span
            className={`rounded-full px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.12em] ${
              BADGE[r.stato] || "bg-[#F3EFF0] text-[#5E2A52]"
            }`}
            data-testid={`richiesta-stato-${r.id}`}
          >
            {r.stato}
          </span>
        </div>
        <p className="mt-2 text-sm text-[#6B5E62]">
          {r.azienda}
          {r.settore ? ` · ${r.settore}` : ""}
        </p>
      </div>
      <p className="text-xs text-[#9B8F92]" data-testid={`richiesta-data-${r.id}`}>
        {formatData(r.created_at)}
      </p>
    </div>

    <div className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
      <a
        href={`mailto:${r.email}`}
        className="inline-flex items-center gap-2 text-[#5E2A52] di-underline"
        data-testid={`richiesta-email-${r.id}`}
      >
        <Mail size={14} className="text-[#E0708A]" /> {r.email}
      </a>
      {r.telefono && (
        <a
          href={`tel:${r.telefono}`}
          className="inline-flex items-center gap-2 text-[#5E2A52] di-underline"
          data-testid={`richiesta-telefono-${r.id}`}
        >
          <Phone size={14} className="text-[#E0708A]" /> {r.telefono}
        </a>
      )}
    </div>

    {r.messaggio && (
      <p
        className="mt-5 whitespace-pre-line rounded-2xl bg-[#FAF9F6] p-5 text-sm leading-relaxed text-[#5B5054]"
        data-testid={`richiesta-messaggio-${r.id}`}
      >
        {r.messaggio}
      </p>
    )}

    <div className="mt-5 flex flex-wrap items-center justify-between gap-4 border-t border-[#F0EBEC] pt-4">
      <div className="flex flex-wrap gap-2">
        {STATI.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            onClick={() => onStato(r, key)}
            disabled={r.stato === key}
            data-testid={`richiesta-set-${key.replace(/ /g, "-")}-${r.id}`}
            className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-xs font-semibold transition-colors duration-300 ${
              r.stato === key
                ? "border-transparent bg-[#5E2A52] text-white"
                : "border-[#E8E2E4] text-[#6B5E62] hover:border-[#E0708A] hover:text-[#E0708A]"
            }`}
          >
            <Icon size={13} /> {label}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-5">
        <span className="text-[11px] text-[#9B8F92]" data-testid={`richiesta-email-esito-${r.id}`}>
          notifica: {esitoEmail(r.email_status)} · risposta: {esitoEmail(r.autoreply_status)}
        </span>
        <button
          onClick={() => onDelete(r)}
          data-testid={`richiesta-delete-${r.id}`}
          className="inline-flex items-center gap-2 text-xs font-semibold text-[#B4404F] transition-colors duration-300 hover:text-[#1A1617]"
        >
          <Trash2 size={14} /> Elimina
        </button>
      </div>
    </div>
  </article>
);
